/**
 * @author alteredq / http://alteredqualia.com/
 */
import * as THREE from "../../../../libs/three.js/build/three.module.js";
 

let Pass = function () {

	// if set to true, the pass is processed by the composer
	this.enabled = true;

	// if set to true, the pass indicates to swap read and write buffer after rendering
	this.needsSwap = true;

	// if set to true, the pass clears its buffer before rendering
	this.clear = false;

	// if set to true, the result of the pass is rendered to screen
	this.renderToScreen = false;

};

Object.assign( Pass.prototype, {

	setSize: function ( width, height ) {},

	render: function ( renderer, writeBuffer, readBuffer, delta, maskActive ) {

		console.error( 'THREE.Pass: .render() must be implemented in derived pass.' );

	}

} );


let ShaderPass = function ( shader, textureID ) {

	Pass.call( this );

	this.textureID = ( textureID !== undefined ) ? textureID : "tDiffuse";

	if ( shader instanceof THREE.ShaderMaterial ) {

		this.uniforms = shader.uniforms;

		this.material = shader;

	} else if ( shader ) {

		this.uniforms = THREE.UniformsUtils.clone( shader.uniforms );

		this.material = new THREE.ShaderMaterial( {

			defines: Object.assign( {}, shader.defines ),
			uniforms: this.uniforms,
			vertexShader: shader.vertexShader,
			fragmentShader: shader.fragmentShader,
            transparent:true,//add 
             
		} );

	}

	this.camera = new THREE.OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
	this.scene = new THREE.Scene();

	this.quad = new THREE.Mesh( new THREE.PlaneBufferGeometry( 2, 2 ), null );
	this.quad.frustumCulled = false; // Avoid getting clipped
	this.scene.add( this.quad );

};

ShaderPass.prototype = Object.assign( Object.create(  Pass.prototype ), {

	constructor: ShaderPass,

	render: function(scene,camera, viewports, renderer, writeBuffer, readBuffer, delta, maskActive ) {
        let oldTarget = renderer.getRenderTarget();
        /* if(this.readTarget){ //add
            readBuffer = oldTarget
        } */


		if ( this.uniforms[ this.textureID ] ) {

			this.uniforms[ this.textureID ].value = readBuffer.texture;

		}

		this.quad.material = this.material;
       
		if ( this.renderToScreen ) {
             
			renderer.render( this.scene, this.camera );

		} else {
            renderer.setRenderTarget(writeBuffer)
            if(this.clear) renderer.clear()
			renderer.render( this.scene, this.camera );
            renderer.setRenderTarget(oldTarget) 
            
            
		}

	}

} );


export {Pass, ShaderPass}